import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const isModified = (state: RootState) => state.pages.editor.scene.isModified;

const isSceneModified = createSelector([isModified], (modified) => modified);

export default isSceneModified;
